import axios from 'axios';
import Url from '../constants/Url';

class AlertsApi {
    getAlerts(params?) {
        const {version} = params || {};
        return axios
            .get(Url(version).GET_ALERTS, {params})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getAlerts:', ex.message);
                throw ex;
            });
    }
}

export default new AlertsApi();
